// A20-P1 / Feb 2026 — Calendar i18n keys for the 18 active languages.
// AR/HE added 2026-06-03 (LLM draft, pending native review) — all 18 active langs covered.
// Merged into TRANSLATIONS by `translations.js`.

export const CALENDAR_I18N = {
  en: {
    navLabel: "Calendar",
    title: "My calendar",
    subtitle: "Your personal events, training sessions, trips and deadlines. Preview only — no external sync.",
    empty: "No events yet. Click \"New event\" to add your first one.",
    refresh: "Refresh",
    new: "New event",
    edit: "Edit",
    deleteAction: "Delete",
    cancel: "Cancel",
    save: "Save",
    confirmDelete: "Delete this event? This is a soft-delete and reversible by an admin.",
    filters: {
      heading: "Filters",
      category: "Category",
      from: "From",
      to: "To",
      all: "All",
    },
    table: {
      title: "Title",
      starts: "Start",
      ends: "End",
      category: "Category",
      location: "Location",
      reminders: "Reminders",
      actions: "Actions",
    },
    form: {
      heading: "Event details",
      titleLabel: "Title",
      descriptionLabel: "Description",
      locationLabel: "Location",
      startsAtLabel: "Start date & time",
      endsAtLabel: "End date & time",
      allDayLabel: "All day",
      colorLabel: "Color",
      categoryLabel: "Category",
      remindersLabel: "Reminders (minutes before)",
      hint: "Plain text only — HTML tags are not allowed.",
    },
    categories: {
      training: "Training",
      match: "Match",
      travel: "Travel",
      meeting: "Meeting",
      deadline: "Deadline",
      personal: "Personal",
      other: "Other",
    },
    colors: {
      slate: "Slate", emerald: "Emerald", violet: "Violet",
      sky: "Sky", amber: "Amber", rose: "Rose",
    },
    reminderOptions: {
      5: "5 min", 15: "15 min", 30: "30 min",
      60: "1 h", 120: "2 h", 360: "6 h",
      1440: "1 day", 2880: "2 days", 10080: "1 week",
    },
    toasts: {
      created: "Event created.",
      updated: "Event updated.",
      deleted: "Event deleted.",
      saveFailed: "Could not save event.",
      endBeforeStart: "End date must be after start date.", startInPast: "Start date cannot be in the past.",
    },
    privacyNotice: "Preview-only · stored on TEAM Preview server · no external sync.",
  },
  es: {
    navLabel: "Calendario",
    title: "Mi calendario",
    subtitle: "Tus eventos personales, entrenamientos, viajes y plazos. Solo Preview — sin sincronización externa.",
    empty: "Aún no hay eventos. Pulsa \"Nuevo evento\" para añadir el primero.",
    refresh: "Actualizar",
    new: "Nuevo evento",
    edit: "Editar",
    deleteAction: "Eliminar",
    cancel: "Cancelar",
    save: "Guardar",
    confirmDelete: "¿Eliminar este evento? Es un borrado lógico, reversible por un admin.",
    filters: { heading: "Filtros", category: "Categoría", from: "Desde", to: "Hasta", all: "Todos" },
    table: { title: "Título", starts: "Inicio", ends: "Fin", category: "Categoría", location: "Ubicación", reminders: "Recordatorios", actions: "Acciones" },
    form: {
      heading: "Detalles del evento",
      titleLabel: "Título", descriptionLabel: "Descripción", locationLabel: "Ubicación",
      startsAtLabel: "Fecha y hora de inicio", endsAtLabel: "Fecha y hora de fin", allDayLabel: "Todo el día",
      colorLabel: "Color", categoryLabel: "Categoría", remindersLabel: "Recordatorios (minutos antes)",
      hint: "Solo texto plano — no se permiten etiquetas HTML.",
    },
    categories: { training: "Entrenamiento", match: "Partido", travel: "Viaje", meeting: "Reunión", deadline: "Fecha límite", personal: "Personal", other: "Otros" },
    colors: { slate: "Pizarra", emerald: "Esmeralda", violet: "Violeta", sky: "Cielo", amber: "Ámbar", rose: "Rosa" },
    reminderOptions: { 5: "5 min", 15: "15 min", 30: "30 min", 60: "1 h", 120: "2 h", 360: "6 h", 1440: "1 día", 2880: "2 días", 10080: "1 semana" },
    toasts: { created: "Evento creado.", updated: "Evento actualizado.", deleted: "Evento eliminado.", saveFailed: "No se pudo guardar el evento.", endBeforeStart: "La fecha final debe ser posterior a la fecha inicial.", startInPast: "La fecha de inicio no puede ser en el pasado." },
    privacyNotice: "Solo Preview · almacenado en el servidor Preview de TEAM · sin sincronización externa.",
  },
  zh: {
    navLabel: "日历", title: "我的日历",
    subtitle: "你的个人事件、训练、出行和截止日期。仅 Preview — 无外部同步。",
    empty: "暂无事件。点击\"新建事件\"添加第一个。",
    refresh: "刷新", new: "新建事件", edit: "编辑", deleteAction: "删除", cancel: "取消", save: "保存",
    confirmDelete: "删除该事件?这是软删除,管理员可恢复。",
    filters: { heading: "筛选", category: "分类", from: "从", to: "至", all: "全部" },
    table: { title: "标题", starts: "开始", ends: "结束", category: "分类", location: "位置", reminders: "提醒", actions: "操作" },
    form: { heading: "事件详情", titleLabel: "标题", descriptionLabel: "描述", locationLabel: "位置", startsAtLabel: "开始", endsAtLabel: "结束", allDayLabel: "全天", colorLabel: "颜色", categoryLabel: "分类", remindersLabel: "提醒(提前分钟)", hint: "仅纯文本 — 不允许 HTML。" },
    categories: { training: "训练", match: "比赛", travel: "出行", meeting: "会议", deadline: "截止", personal: "个人", other: "其他" },
    colors: { slate: "石板", emerald: "翠绿", violet: "紫色", sky: "天蓝", amber: "琥珀", rose: "玫瑰" },
    reminderOptions: { 5: "5 分钟", 15: "15 分钟", 30: "30 分钟", 60: "1 小时", 120: "2 小时", 360: "6 小时", 1440: "1 天", 2880: "2 天", 10080: "1 周" },
    toasts: { created: "已创建。", updated: "已更新。", deleted: "已删除。", saveFailed: "保存失败。", endBeforeStart: "结束日期必须晚于开始日期。", startInPast: "开始日期不能在过去。" },
    privacyNotice: "仅 Preview · 数据存储于 TEAM Preview 服务器 · 无外部同步。",
  },
  it: {
    navLabel: "Calendario", title: "Il mio calendario",
    subtitle: "Eventi personali, allenamenti, viaggi e scadenze. Solo Preview — nessuna sincronizzazione esterna.",
    empty: "Nessun evento. Premi \"Nuovo evento\" per aggiungere il primo.",
    refresh: "Aggiorna", new: "Nuovo evento", edit: "Modifica", deleteAction: "Elimina", cancel: "Annulla", save: "Salva",
    confirmDelete: "Eliminare questo evento? È una soft-delete, reversibile da un admin.",
    filters: { heading: "Filtri", category: "Categoria", from: "Da", to: "A", all: "Tutti" },
    table: { title: "Titolo", starts: "Inizio", ends: "Fine", category: "Categoria", location: "Luogo", reminders: "Promemoria", actions: "Azioni" },
    form: { heading: "Dettagli evento", titleLabel: "Titolo", descriptionLabel: "Descrizione", locationLabel: "Luogo", startsAtLabel: "Inizio", endsAtLabel: "Fine", allDayLabel: "Tutto il giorno", colorLabel: "Colore", categoryLabel: "Categoria", remindersLabel: "Promemoria (minuti prima)", hint: "Solo testo — niente HTML." },
    categories: { training: "Allenamento", match: "Partita", travel: "Viaggio", meeting: "Riunione", deadline: "Scadenza", personal: "Personale", other: "Altro" },
    colors: { slate: "Ardesia", emerald: "Smeraldo", violet: "Viola", sky: "Cielo", amber: "Ambra", rose: "Rosa" },
    reminderOptions: { 5: "5 min", 15: "15 min", 30: "30 min", 60: "1 h", 120: "2 h", 360: "6 h", 1440: "1 giorno", 2880: "2 giorni", 10080: "1 settimana" },
    toasts: { created: "Evento creato.", updated: "Evento aggiornato.", deleted: "Evento eliminato.", saveFailed: "Impossibile salvare.", endBeforeStart: "La data finale deve essere successiva a quella iniziale.", startInPast: "La data di inizio non può essere nel passato." },
    privacyNotice: "Solo Preview · archiviato sul server Preview TEAM · nessuna sincronizzazione esterna.",
  },
  fr: {
    navLabel: "Calendrier", title: "Mon calendrier",
    subtitle: "Tes événements personnels, entraînements, voyages et échéances. Preview uniquement — pas de sync externe.",
    empty: "Aucun événement. Clique sur \"Nouvel événement\" pour en ajouter un.",
    refresh: "Actualiser", new: "Nouvel événement", edit: "Modifier", deleteAction: "Supprimer", cancel: "Annuler", save: "Enregistrer",
    confirmDelete: "Supprimer cet événement ? Soft-delete, réversible par un admin.",
    filters: { heading: "Filtres", category: "Catégorie", from: "De", to: "À", all: "Tous" },
    table: { title: "Titre", starts: "Début", ends: "Fin", category: "Catégorie", location: "Lieu", reminders: "Rappels", actions: "Actions" },
    form: { heading: "Détails de l'événement", titleLabel: "Titre", descriptionLabel: "Description", locationLabel: "Lieu", startsAtLabel: "Début", endsAtLabel: "Fin", allDayLabel: "Toute la journée", colorLabel: "Couleur", categoryLabel: "Catégorie", remindersLabel: "Rappels (minutes avant)", hint: "Texte brut uniquement — pas de HTML." },
    categories: { training: "Entraînement", match: "Match", travel: "Voyage", meeting: "Réunion", deadline: "Échéance", personal: "Personnel", other: "Autre" },
    colors: { slate: "Ardoise", emerald: "Émeraude", violet: "Violet", sky: "Ciel", amber: "Ambre", rose: "Rose" },
    reminderOptions: { 5: "5 min", 15: "15 min", 30: "30 min", 60: "1 h", 120: "2 h", 360: "6 h", 1440: "1 jour", 2880: "2 jours", 10080: "1 semaine" },
    toasts: { created: "Événement créé.", updated: "Événement mis à jour.", deleted: "Événement supprimé.", saveFailed: "Impossible d'enregistrer.", endBeforeStart: "La date de fin doit être postérieure à la date de début.", startInPast: "La date de début ne peut pas être dans le passé." },
    privacyNotice: "Preview uniquement · stocké sur le serveur Preview TEAM · pas de sync externe.",
  },
  de: {
    navLabel: "Kalender", title: "Mein Kalender",
    subtitle: "Persönliche Events, Trainings, Reisen und Deadlines. Nur Preview — keine externe Sync.",
    empty: "Noch keine Events. Klicke auf \"Neues Event\".",
    refresh: "Aktualisieren", new: "Neues Event", edit: "Bearbeiten", deleteAction: "Löschen", cancel: "Abbrechen", save: "Speichern",
    confirmDelete: "Dieses Event löschen? Soft-Delete, durch Admin reversibel.",
    filters: { heading: "Filter", category: "Kategorie", from: "Von", to: "Bis", all: "Alle" },
    table: { title: "Titel", starts: "Beginn", ends: "Ende", category: "Kategorie", location: "Ort", reminders: "Erinnerungen", actions: "Aktionen" },
    form: { heading: "Event-Details", titleLabel: "Titel", descriptionLabel: "Beschreibung", locationLabel: "Ort", startsAtLabel: "Beginn", endsAtLabel: "Ende", allDayLabel: "Ganztägig", colorLabel: "Farbe", categoryLabel: "Kategorie", remindersLabel: "Erinnerungen (Minuten vorher)", hint: "Nur Klartext — kein HTML." },
    categories: { training: "Training", match: "Spiel", travel: "Reise", meeting: "Meeting", deadline: "Deadline", personal: "Persönlich", other: "Sonstiges" },
    colors: { slate: "Schiefer", emerald: "Smaragd", violet: "Violett", sky: "Himmel", amber: "Bernstein", rose: "Rose" },
    reminderOptions: { 5: "5 Min", 15: "15 Min", 30: "30 Min", 60: "1 Std", 120: "2 Std", 360: "6 Std", 1440: "1 Tag", 2880: "2 Tage", 10080: "1 Woche" },
    toasts: { created: "Event erstellt.", updated: "Event aktualisiert.", deleted: "Event gelöscht.", saveFailed: "Event konnte nicht gespeichert werden.", endBeforeStart: "Das Enddatum muss nach dem Startdatum liegen.", startInPast: "Das Startdatum darf nicht in der Vergangenheit liegen." },
    privacyNotice: "Nur Preview · auf dem TEAM-Preview-Server gespeichert · keine externe Sync.",
  },
  "pt-br": {
    navLabel: "Calendário", title: "Meu calendário",
    subtitle: "Eventos pessoais, treinos, viagens e prazos. Apenas Preview — sem sincronização externa.",
    empty: "Sem eventos. Clique em \"Novo evento\".",
    refresh: "Atualizar", new: "Novo evento", edit: "Editar", deleteAction: "Excluir", cancel: "Cancelar", save: "Salvar",
    confirmDelete: "Excluir este evento? Soft-delete, reversível por admin.",
    filters: { heading: "Filtros", category: "Categoria", from: "De", to: "Até", all: "Todos" },
    table: { title: "Título", starts: "Início", ends: "Fim", category: "Categoria", location: "Local", reminders: "Lembretes", actions: "Ações" },
    form: { heading: "Detalhes do evento", titleLabel: "Título", descriptionLabel: "Descrição", locationLabel: "Local", startsAtLabel: "Início", endsAtLabel: "Fim", allDayLabel: "Dia todo", colorLabel: "Cor", categoryLabel: "Categoria", remindersLabel: "Lembretes (min antes)", hint: "Apenas texto — sem HTML." },
    categories: { training: "Treino", match: "Partida", travel: "Viagem", meeting: "Reunião", deadline: "Prazo", personal: "Pessoal", other: "Outro" },
    colors: { slate: "Ardósia", emerald: "Esmeralda", violet: "Violeta", sky: "Céu", amber: "Âmbar", rose: "Rosa" },
    reminderOptions: { 5: "5 min", 15: "15 min", 30: "30 min", 60: "1 h", 120: "2 h", 360: "6 h", 1440: "1 dia", 2880: "2 dias", 10080: "1 semana" },
    toasts: { created: "Evento criado.", updated: "Evento atualizado.", deleted: "Evento excluído.", saveFailed: "Não foi possível salvar.", endBeforeStart: "A data final deve ser posterior à data inicial.", startInPast: "A data de início não pode estar no passado." },
    privacyNotice: "Apenas Preview · armazenado no servidor Preview TEAM · sem sincronização externa.",
  },
  ja: {
    navLabel: "カレンダー", title: "マイカレンダー",
    subtitle: "個人のイベント、トレーニング、移動、締切。Preview のみ — 外部同期なし。",
    empty: "まだイベントがありません。\"新規イベント\"を押してください。",
    refresh: "更新", new: "新規イベント", edit: "編集", deleteAction: "削除", cancel: "キャンセル", save: "保存",
    confirmDelete: "このイベントを削除しますか?ソフト削除で管理者が復元できます。",
    filters: { heading: "フィルタ", category: "カテゴリ", from: "開始", to: "終了", all: "すべて" },
    table: { title: "タイトル", starts: "開始", ends: "終了", category: "カテゴリ", location: "場所", reminders: "リマインダー", actions: "操作" },
    form: { heading: "イベント詳細", titleLabel: "タイトル", descriptionLabel: "説明", locationLabel: "場所", startsAtLabel: "開始", endsAtLabel: "終了", allDayLabel: "終日", colorLabel: "色", categoryLabel: "カテゴリ", remindersLabel: "リマインダー(分前)", hint: "プレーンテキストのみ — HTML 不可。" },
    categories: { training: "練習", match: "試合", travel: "移動", meeting: "会議", deadline: "締切", personal: "個人", other: "その他" },
    colors: { slate: "スレート", emerald: "エメラルド", violet: "バイオレット", sky: "スカイ", amber: "アンバー", rose: "ローズ" },
    reminderOptions: { 5: "5 分", 15: "15 分", 30: "30 分", 60: "1 時間", 120: "2 時間", 360: "6 時間", 1440: "1 日", 2880: "2 日", 10080: "1 週間" },
    toasts: { created: "作成しました。", updated: "更新しました。", deleted: "削除しました。", saveFailed: "保存できませんでした。", endBeforeStart: "終了日時は開始日時より後である必要があります。", startInPast: "開始日時を過去にすることはできません。" },
    privacyNotice: "Preview のみ · TEAM Preview サーバーに保存 · 外部同期なし。",
  },
  hi: {
    navLabel: "कैलेंडर", title: "मेरा कैलेंडर",
    subtitle: "व्यक्तिगत आयोजन, अभ्यास, यात्राएँ और समय-सीमाएँ। केवल Preview — कोई बाहरी सिंक नहीं।",
    empty: "अभी कोई आयोजन नहीं। \"नया आयोजन\" पर क्लिक करें।",
    refresh: "रिफ़्रेश", new: "नया आयोजन", edit: "संपादित करें", deleteAction: "मिटाएँ", cancel: "रद्द करें", save: "सहेजें",
    confirmDelete: "यह आयोजन मिटाएँ? सॉफ़्ट-डिलीट, एडमिन पलट सकते हैं।",
    filters: { heading: "फ़िल्टर", category: "श्रेणी", from: "से", to: "तक", all: "सभी" },
    table: { title: "शीर्षक", starts: "प्रारंभ", ends: "समाप्त", category: "श्रेणी", location: "स्थान", reminders: "रिमाइंडर", actions: "क्रियाएँ" },
    form: { heading: "आयोजन विवरण", titleLabel: "शीर्षक", descriptionLabel: "विवरण", locationLabel: "स्थान", startsAtLabel: "प्रारंभ", endsAtLabel: "समाप्त", allDayLabel: "पूरा दिन", colorLabel: "रंग", categoryLabel: "श्रेणी", remindersLabel: "रिमाइंडर (मिनट पहले)", hint: "केवल सादा पाठ — HTML की अनुमति नहीं।" },
    categories: { training: "अभ्यास", match: "मैच", travel: "यात्रा", meeting: "बैठक", deadline: "समय-सीमा", personal: "व्यक्तिगत", other: "अन्य" },
    colors: { slate: "स्लेट", emerald: "ज़मरुदी", violet: "बैंगनी", sky: "आसमानी", amber: "एम्बर", rose: "गुलाबी" },
    reminderOptions: { 5: "5 मिनट", 15: "15 मिनट", 30: "30 मिनट", 60: "1 घंटा", 120: "2 घंटे", 360: "6 घंटे", 1440: "1 दिन", 2880: "2 दिन", 10080: "1 सप्ताह" },
    toasts: { created: "आयोजन बना।", updated: "अद्यतित।", deleted: "मिटाया।", saveFailed: "सहेजने में विफल।", endBeforeStart: "अंतिम तिथि प्रारंभ तिथि के बाद होनी चाहिए।", startInPast: "प्रारंभ तिथि अतीत में नहीं हो सकती।" },
    privacyNotice: "केवल Preview · TEAM Preview सर्वर पर संग्रहीत · कोई बाहरी सिंक नहीं।",
  },
  ko: {
    navLabel: "캘린더", title: "내 캘린더",
    subtitle: "개인 일정, 훈련, 이동, 마감일. Preview 전용 — 외부 동기화 없음.",
    empty: "아직 일정이 없습니다. \"새 일정\"을 눌러 추가하세요.",
    refresh: "새로고침", new: "새 일정", edit: "편집", deleteAction: "삭제", cancel: "취소", save: "저장",
    confirmDelete: "이 일정을 삭제할까요? 소프트 삭제이며 관리자가 복구할 수 있습니다.",
    filters: { heading: "필터", category: "카테고리", from: "시작", to: "끝", all: "전체" },
    table: { title: "제목", starts: "시작", ends: "종료", category: "카테고리", location: "장소", reminders: "알림", actions: "작업" },
    form: { heading: "일정 세부정보", titleLabel: "제목", descriptionLabel: "설명", locationLabel: "장소", startsAtLabel: "시작", endsAtLabel: "종료", allDayLabel: "종일", colorLabel: "색상", categoryLabel: "카테고리", remindersLabel: "알림(분 전)", hint: "일반 텍스트만 — HTML 금지." },
    categories: { training: "훈련", match: "경기", travel: "이동", meeting: "회의", deadline: "마감", personal: "개인", other: "기타" },
    colors: { slate: "슬레이트", emerald: "에메랄드", violet: "바이올렛", sky: "스카이", amber: "앰버", rose: "로즈" },
    reminderOptions: { 5: "5분", 15: "15분", 30: "30분", 60: "1시간", 120: "2시간", 360: "6시간", 1440: "1일", 2880: "2일", 10080: "1주" },
    toasts: { created: "생성되었습니다.", updated: "업데이트되었습니다.", deleted: "삭제되었습니다.", saveFailed: "저장하지 못했습니다.", endBeforeStart: "종료 일시는 시작 일시 이후여야 합니다.", startInPast: "시작 일시는 과거일 수 없습니다." },
    privacyNotice: "Preview 전용 · TEAM Preview 서버 저장 · 외부 동기화 없음.",
  },
  ru: {
    navLabel: "Календарь", title: "Мой календарь",
    subtitle: "Личные события, тренировки, поездки и сроки. Только Preview — без внешней синхронизации.",
    empty: "Событий пока нет. Нажмите \"Новое событие\".",
    refresh: "Обновить", new: "Новое событие", edit: "Изменить", deleteAction: "Удалить", cancel: "Отмена", save: "Сохранить",
    confirmDelete: "Удалить событие? Мягкое удаление, обратимо администратором.",
    filters: { heading: "Фильтры", category: "Категория", from: "С", to: "По", all: "Все" },
    table: { title: "Название", starts: "Начало", ends: "Конец", category: "Категория", location: "Место", reminders: "Напоминания", actions: "Действия" },
    form: { heading: "Параметры события", titleLabel: "Название", descriptionLabel: "Описание", locationLabel: "Место", startsAtLabel: "Начало", endsAtLabel: "Конец", allDayLabel: "Весь день", colorLabel: "Цвет", categoryLabel: "Категория", remindersLabel: "Напоминания (минут до)", hint: "Только текст — без HTML." },
    categories: { training: "Тренировка", match: "Матч", travel: "Поездка", meeting: "Встреча", deadline: "Дедлайн", personal: "Личное", other: "Другое" },
    colors: { slate: "Сланец", emerald: "Изумруд", violet: "Фиолет", sky: "Небо", amber: "Янтарь", rose: "Роза" },
    reminderOptions: { 5: "5 мин", 15: "15 мин", 30: "30 мин", 60: "1 ч", 120: "2 ч", 360: "6 ч", 1440: "1 день", 2880: "2 дня", 10080: "1 неделя" },
    toasts: { created: "Событие создано.", updated: "Событие обновлено.", deleted: "Событие удалено.", saveFailed: "Не удалось сохранить.", endBeforeStart: "Дата окончания должна быть позже даты начала.", startInPast: "Дата начала не может быть в прошлом." },
    privacyNotice: "Только Preview · хранится на сервере TEAM Preview · без внешней синхронизации.",
  },
  cs: {
    navLabel: "Kalendář", title: "Můj kalendář",
    subtitle: "Osobní události, tréninky, cesty a termíny. Pouze Preview — bez externí synchronizace.",
    empty: "Žádné události. Klikněte na \"Nová událost\".",
    refresh: "Obnovit", new: "Nová událost", edit: "Upravit", deleteAction: "Smazat", cancel: "Zrušit", save: "Uložit",
    confirmDelete: "Smazat tuto událost? Soft-delete, vratné adminem.",
    filters: { heading: "Filtry", category: "Kategorie", from: "Od", to: "Do", all: "Vše" },
    table: { title: "Název", starts: "Začátek", ends: "Konec", category: "Kategorie", location: "Místo", reminders: "Připomenutí", actions: "Akce" },
    form: { heading: "Detaily události", titleLabel: "Název", descriptionLabel: "Popis", locationLabel: "Místo", startsAtLabel: "Začátek", endsAtLabel: "Konec", allDayLabel: "Celý den", colorLabel: "Barva", categoryLabel: "Kategorie", remindersLabel: "Připomenutí (min. před)", hint: "Pouze prostý text — žádné HTML." },
    categories: { training: "Trénink", match: "Zápas", travel: "Cesta", meeting: "Schůzka", deadline: "Termín", personal: "Osobní", other: "Jiné" },
    colors: { slate: "Břidlice", emerald: "Smaragd", violet: "Fialová", sky: "Nebeská", amber: "Jantar", rose: "Růžová" },
    reminderOptions: { 5: "5 min", 15: "15 min", 30: "30 min", 60: "1 h", 120: "2 h", 360: "6 h", 1440: "1 den", 2880: "2 dny", 10080: "1 týden" },
    toasts: { created: "Událost vytvořena.", updated: "Událost aktualizována.", deleted: "Událost smazána.", saveFailed: "Nelze uložit.", endBeforeStart: "Datum konce musí být po datu začátku.", startInPast: "Datum začátku nemůže být v minulosti." },
    privacyNotice: "Pouze Preview · uloženo na serveru TEAM Preview · bez externí synchronizace.",
  },
  nl: {
    navLabel: "Agenda", title: "Mijn agenda",
    subtitle: "Persoonlijke events, trainingen, reizen en deadlines. Alleen Preview — geen externe sync.",
    empty: "Nog geen events. Klik op \"Nieuw event\".",
    refresh: "Vernieuwen", new: "Nieuw event", edit: "Bewerken", deleteAction: "Verwijderen", cancel: "Annuleren", save: "Opslaan",
    confirmDelete: "Dit event verwijderen? Soft-delete, omkeerbaar door admin.",
    filters: { heading: "Filters", category: "Categorie", from: "Van", to: "Tot", all: "Alles" },
    table: { title: "Titel", starts: "Start", ends: "Einde", category: "Categorie", location: "Locatie", reminders: "Herinneringen", actions: "Acties" },
    form: { heading: "Eventdetails", titleLabel: "Titel", descriptionLabel: "Beschrijving", locationLabel: "Locatie", startsAtLabel: "Start", endsAtLabel: "Einde", allDayLabel: "Hele dag", colorLabel: "Kleur", categoryLabel: "Categorie", remindersLabel: "Herinneringen (min vooraf)", hint: "Alleen platte tekst — geen HTML." },
    categories: { training: "Training", match: "Wedstrijd", travel: "Reis", meeting: "Vergadering", deadline: "Deadline", personal: "Persoonlijk", other: "Anders" },
    colors: { slate: "Leisteen", emerald: "Smaragd", violet: "Violet", sky: "Lucht", amber: "Amber", rose: "Roze" },
    reminderOptions: { 5: "5 min", 15: "15 min", 30: "30 min", 60: "1 u", 120: "2 u", 360: "6 u", 1440: "1 dag", 2880: "2 dagen", 10080: "1 week" },
    toasts: { created: "Event aangemaakt.", updated: "Event bijgewerkt.", deleted: "Event verwijderd.", saveFailed: "Opslaan mislukt.", endBeforeStart: "De einddatum moet na de begindatum liggen.", startInPast: "De startdatum mag niet in het verleden liggen." },
    privacyNotice: "Alleen Preview · opgeslagen op TEAM Preview-server · geen externe sync.",
  },

  // // PHASE_A19_LLM_SCAFFOLD — ca bucket (2026-06-01T16:25:07+00:00)
  // translation_status: draft_pending_native_review
  // source_model: anthropic/claude-sonnet-4-5-20250929
  // source_lang: es
  ca: {
    navLabel: "Calendari",
    title: "El meu calendari",
    subtitle: "Els teus esdeveniments personals, entrenaments, viatges i terminis. Només Preview — sense sincronització externa.",
    empty: "Encara no hi ha esdeveniments. Prem \"Nou esdeveniment\" per afegir el primer.",
    refresh: "Actualitzar",
    new: "Nou esdeveniment",
    edit: "Editar",
    deleteAction: "Eliminar",
    cancel: "Cancel·lar",
    save: "Desar",
    confirmDelete: "Eliminar aquest esdeveniment? És un esborrat lògic, reversible per un admin.",
    filters: {
      heading: "Filtres",
      category: "Categoria",
      from: "Des de",
      to: "Fins a",
      all: "Tots",
    },
    table: {
      title: "Títol",
      starts: "Inici",
      ends: "Fi",
      category: "Categoria",
      location: "Ubicació",
      reminders: "Recordatoris",
      actions: "Accions",
    },
    form: {
      heading: "Detalls de l'esdeveniment",
      titleLabel: "Títol",
      descriptionLabel: "Descripció",
      locationLabel: "Ubicació",
      startsAtLabel: "Data i hora d'inici",
      endsAtLabel: "Data i hora de fi",
      allDayLabel: "Tot el dia",
      colorLabel: "Color",
      categoryLabel: "Categoria",
      remindersLabel: "Recordatoris (minuts abans)",
      hint: "Només text pla — no es permeten etiquetes HTML.",
    },
    categories: {
      training: "Entrenament",
      match: "Partit",
      travel: "Viatge",
      meeting: "Reunió",
      deadline: "Data límit",
      personal: "Personal",
      other: "Altres",
    },
    colors: {
      slate: "Pissarra",
      emerald: "Maragda",
      violet: "Violeta",
      sky: "Cel",
      amber: "Àmbar",
      rose: "Rosa",
    },
    reminderOptions: {
      "5": "5 min",
      "15": "15 min",
      "30": "30 min",
      "60": "1 h",
      "120": "2 h",
      "360": "6 h",
      "1440": "1 dia",
      "2880": "2 dies",
      "10080": "1 setmana",
    },
    toasts: {
      created: "Esdeveniment creat.",
      updated: "Esdeveniment actualitzat.",
      deleted: "Esdeveniment eliminat.",
      saveFailed: "No s'ha pogut desar l'esdeveniment.",
      endBeforeStart: "La data final ha de ser posterior a la data inicial.",
      startInPast: "La data d'inici no pot ser en el passat.",
    },
    privacyNotice: "Només Preview · emmagatzemat al servidor Preview de TEAM · sense sincronització externa.",
  },

  // // PHASE_A19_LLM_SCAFFOLD — eu bucket (2026-06-01T16:25:22+00:00)
  // translation_status: draft_pending_native_review
  // source_model: anthropic/claude-sonnet-4-5-20250929
  // source_lang: es
  eu: {
    navLabel: "Egutegia",
    title: "Nire egutegia",
    subtitle: "Zure ekitaldi pertsonalak, entrenamenduk, bidaiak eta epemugak. Aurrebista soilik — kanpoko sinkronizaziorik ez.",
    empty: "Oraindik ez dago ekitaldirik. Sakatu \"Ekitaldi berria\" lehenengoa gehitzeko.",
    refresh: "Eguneratu",
    new: "Ekitaldi berria",
    edit: "Editatu",
    deleteAction: "Ezabatu",
    cancel: "Utzi",
    save: "Gorde",
    confirmDelete: "Ekitaldi hau ezabatu? Ezabatze logikoa da, admin batek leheneratu dezake.",
    filters: {
      heading: "Iragazkiak",
      category: "Kategoria",
      from: "Hasiera",
      to: "Bukaera",
      all: "Denak",
    },
    table: {
      title: "Izenburua",
      starts: "Hasiera",
      ends: "Amaiera",
      category: "Kategoria",
      location: "Kokapena",
      reminders: "Oroigarriak",
      actions: "Ekintzak",
    },
    form: {
      heading: "Ekitaldiaren xehetasunak",
      titleLabel: "Izenburua",
      descriptionLabel: "Deskribapena",
      locationLabel: "Kokapena",
      startsAtLabel: "Hasiera data eta ordua",
      endsAtLabel: "Amaiera data eta ordua",
      allDayLabel: "Egun osoa",
      colorLabel: "Kolorea",
      categoryLabel: "Kategoria",
      remindersLabel: "Oroigarriak (minutu lehenago)",
      hint: "Testu arrunta soilik — HTML etiketak ez dira onartzen.",
    },
    categories: {
      training: "Entrenamendua",
      match: "Partida",
      travel: "Bidaia",
      meeting: "Bilera",
      deadline: "Epemuga",
      personal: "Pertsonala",
      other: "Bestelakoak",
    },
    colors: {
      slate: "Arbela",
      emerald: "Esmeralda",
      violet: "Bioleta",
      sky: "Zerua",
      amber: "Anbar",
      rose: "Arrosa",
    },
    reminderOptions: {
      "5": "5 min",
      "15": "15 min",
      "30": "30 min",
      "60": "1 o",
      "120": "2 o",
      "360": "6 o",
      "1440": "1 egun",
      "2880": "2 egun",
      "10080": "1 aste",
    },
    toasts: {
      created: "Ekitaldia sortua.",
      updated: "Ekitaldia eguneratua.",
      deleted: "Ekitaldia ezabatua.",
      saveFailed: "Ezin izan da ekitaldia gorde.",
      endBeforeStart: "Amaiera data hasiera data baino beranduagokoa izan behar da.",
      startInPast: "Hasiera data ezin da iraganekoa izan.",
    },
    privacyNotice: "Aurrebista soilik · TEAM-en Aurrebista zerbitzarian gordetua · kanpoko sinkronizaziorik ez.",
  },

  // // PHASE_A19_LLM_SCAFFOLD — gl bucket (2026-06-01T16:25:32+00:00)
  // translation_status: draft_pending_native_review
  // source_model: anthropic/claude-sonnet-4-5-20250929
  // source_lang: es
  gl: {
    navLabel: "Calendario",
    title: "O meu calendario",
    subtitle: "Os teus eventos persoais, adestramentos, viaxes e prazos. Só Preview — sen sincronización externa.",
    empty: "Aínda non hai eventos. Preme \"Novo evento\" para engadir o primeiro.",
    refresh: "Actualizar",
    new: "Novo evento",
    edit: "Editar",
    deleteAction: "Eliminar",
    cancel: "Cancelar",
    save: "Gardar",
    confirmDelete: "Eliminar este evento? É un borrado lóxico, reversible por un admin.",
    filters: {
      heading: "Filtros",
      category: "Categoría",
      from: "Desde",
      to: "Ata",
      all: "Todos",
    },
    table: {
      title: "Título",
      starts: "Inicio",
      ends: "Fin",
      category: "Categoría",
      location: "Localización",
      reminders: "Recordatorios",
      actions: "Accións",
    },
    form: {
      heading: "Detalles do evento",
      titleLabel: "Título",
      descriptionLabel: "Descrición",
      locationLabel: "Localización",
      startsAtLabel: "Data e hora de inicio",
      endsAtLabel: "Data e hora de fin",
      allDayLabel: "Todo o día",
      colorLabel: "Cor",
      categoryLabel: "Categoría",
      remindersLabel: "Recordatorios (minutos antes)",
      hint: "Só texto plano — non se permiten etiquetas HTML.",
    },
    categories: {
      training: "Adestramento",
      match: "Partido",
      travel: "Viaxe",
      meeting: "Reunión",
      deadline: "Data límite",
      personal: "Persoal",
      other: "Outros",
    },
    colors: {
      slate: "Lousa",
      emerald: "Esmeralda",
      violet: "Violeta",
      sky: "Ceo",
      amber: "Ámbar",
      rose: "Rosa",
    },
    reminderOptions: {
      "5": "5 min",
      "15": "15 min",
      "30": "30 min",
      "60": "1 h",
      "120": "2 h",
      "360": "6 h",
      "1440": "1 día",
      "2880": "2 días",
      "10080": "1 semana",
    },
    toasts: {
      created: "Evento creado.",
      updated: "Evento actualizado.",
      deleted: "Evento eliminado.",
      saveFailed: "Non se puido gardar o evento.",
      endBeforeStart: "A data final debe ser posterior á data inicial.",
      startInPast: "A data de inicio non pode ser no pasado.",
    },
    privacyNotice: "Só Preview · almacenado no servidor Preview de TEAM · sen sincronización externa.",
  },
  ar: {
    navLabel: "التقويم",
    title: "تقويمي",
    subtitle: "فعالياتك الشخصية وجلسات التدريب والرحلات والمواعيد النهائية. للمعاينة فقط — لا توجد مزامنة خارجية.",
    empty: "لا توجد فعاليات بعد. انقر \"فعالية جديدة\" لإضافة الأولى.",
    refresh: "تحديث",
    new: "فعالية جديدة",
    edit: "تعديل",
    deleteAction: "حذف",
    cancel: "إلغاء",
    save: "حفظ",
    confirmDelete: "حذف هذه الفعالية؟ هذا حذف مؤقت ويمكن للمسؤول التراجع عنه.",
    filters: {
      heading: "التصفية",
      category: "الفئة",
      from: "من",
      to: "إلى",
      all: "الكل",
    },
    table: {
      title: "العنوان",
      starts: "البداية",
      ends: "النهاية",
      category: "الفئة",
      location: "الموقع",
      reminders: "التذكيرات",
      actions: "الإجراءات",
    },
    form: {
      heading: "تفاصيل الفعالية",
      titleLabel: "العنوان",
      descriptionLabel: "الوصف",
      locationLabel: "الموقع",
      startsAtLabel: "تاريخ ووقت البداية",
      endsAtLabel: "تاريخ ووقت النهاية",
      allDayLabel: "طوال اليوم",
      colorLabel: "اللون",
      categoryLabel: "الفئة",
      remindersLabel: "التذكيرات (دقائق قبل الموعد)",
      hint: "نص عادي فقط — لا يُسمح بعلامات HTML.",
    },
    categories: {
      training: "تدريب",
      match: "مباراة",
      travel: "سفر",
      meeting: "اجتماع",
      deadline: "موعد نهائي",
      personal: "شخصي",
      other: "أخرى",
    },
    colors: {
      slate: "رمادي",
      emerald: "زمردي",
      violet: "بنفسجي",
      sky: "سماوي",
      amber: "عنبري",
      rose: "وردي",
    },
    reminderOptions: {
      "5": "5 دقائق",
      "15": "15 دقيقة",
      "30": "30 دقيقة",
      "60": "ساعة",
      "120": "ساعتان",
      "360": "6 ساعات",
      "1440": "يوم",
      "2880": "يومان",
      "10080": "أسبوع",
    },
    toasts: {
      created: "تم إنشاء الفعالية.",
      updated: "تم تحديث الفعالية.",
      deleted: "تم حذف الفعالية.",
      saveFailed: "تعذر حفظ الفعالية.",
      endBeforeStart: "يجب أن يكون تاريخ النهاية بعد تاريخ البداية.",
      startInPast: "لا يمكن أن يكون تاريخ البداية في الماضي.",
    },
    privacyNotice: "للمعاينة فقط · مخزّن على خادم TEAM Preview · لا توجد مزامنة خارجية.",
  },
  he: {
    navLabel: "יומן",
    title: "היומן שלי",
    subtitle: "האירועים האישיים שלך, אימונים, נסיעות ותאריכי יעד. תצוגה בלבד - ללא סנכרון חיצוני.",
    empty: "אין אירועים עדיין. לחץ על \"אירוע חדש\" כדי להוסיף את הראשון שלך.",
    refresh: "רענן",
    new: "אירוע חדש",
    edit: "ערוך",
    deleteAction: "מחק",
    cancel: "ביטול",
    save: "שמור",
    confirmDelete: "למחוק אירוע זה? זוהי מחיקה רכה וניתנת לשחזור על-ידי מנהל.",
    filters: {
      heading: "סינון",
      category: "קטגוריה",
      from: "מתאריך",
      to: "עד תאריך",
      all: "הכל",
    },
    table: {
      title: "כותרת",
      starts: "התחלה",
      ends: "סיום",
      category: "קטגוריה",
      location: "מיקום",
      reminders: "תזכורות",
      actions: "פעולות",
    },
    form: {
      heading: "פרטי האירוע",
      titleLabel: "כותרת",
      descriptionLabel: "תיאור",
      locationLabel: "מיקום",
      startsAtLabel: "תאריך ושעת התחלה",
      endsAtLabel: "תאריך ושעת סיום",
      allDayLabel: "כל היום",
      colorLabel: "צבע",
      categoryLabel: "קטגוריה",
      remindersLabel: "תזכורות (דקות לפני)",
      hint: "טקסט פשוט בלבד - תגי HTML אינם מותרים.",
    },
    categories: {
      training: "אימון",
      match: "משחק",
      travel: "נסיעה",
      meeting: "פגישה",
      deadline: "מועד אחרון",
      personal: "אישי",
      other: "אחר",
    },
    colors: {
      slate: "אפור כהה",
      emerald: "ירוק אמרלד",
      violet: "סגול",
      sky: "תכלת",
      amber: "ענבר",
      rose: "ורוד",
    },
    reminderOptions: {
      "5": "5 דק׳",
      "15": "15 דק׳",
      "30": "30 דק׳",
      "60": "שעה",
      "120": "שעתיים",
      "360": "6 שעות",
      "1440": "יום",
      "2880": "יומיים",
      "10080": "שבוע",
    },
    toasts: {
      created: "אירוע נוצר.",
      updated: "אירוע עודכן.",
      deleted: "אירוע נמחק.",
      saveFailed: "לא ניתן לשמור את האירוע.",
      endBeforeStart: "תאריך הסיום חייב להיות אחרי תאריך ההתחלה.",
      startInPast: "תאריך ההתחלה לא יכול להיות בעבר.",
    },
    privacyNotice: "תצוגה בלבד · מאוחסן בשרת TEAM Preview · ללא סנכרון חיצוני.",
  },

};
